// extracted by mini-css-extract-plugin
export default {"notification":"pullCardTip_notification__wyV2z"};